export default __webpack_public_path__ + "static/media/launched-2.94337614.jpg";